import React from 'react';

function RadioQuestion({ question, value, onChange }) {
  return (
    <div className="options-container">
      {question.options.map(option => (
        <div
          key={option.value}
          className={`option-item ${value === option.value ? 'selected' : ''}`}
          onClick={() => onChange(option.value)}
        >
          <input
            type="radio"
            name={question.id}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          <span className="option-label">{option.label}</span>
        </div>
      ))}
    </div>
  );
}

export default RadioQuestion;
